import { axios } from '@/utils/request'
import qs from 'qs'

const config = {
  clientId: 'sys_org_pc', // 应用id
  clientSecret: 'sys_org_pc' // 应用秘钥
}


//微信登录获取二维码图片
export function webQrCode (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/webQrCode',
    method: 'get',
    params: parameter
  })
}
//个人用户注册第1步,根据电话号码 ---- 验证码
export function getChangeCode (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/reg/one',
    method: 'get',
    params: parameter
  })
}

//个人用户注册第2步,已存在则更新user表或要
export function personReg (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/reg/two',
    method: 'put',
    data: parameter
  })
}
//个人用户注册第3步,填写详细资料
export function personRegThree (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/reg/three',
    method: 'put',
    data: parameter
  })
}
 
 //用户登录--- 注销
export function unRegist () {
  return axios({
    url: '/api-user-v2/personal/login/user/unRegist',
    method: 'get',
  })
}
 //用户登录--- 用户详情
export function getInfo (parameter) {
  return axios({
    url: '/api-user-v2/personal/login/user/info',
    method: 'get',
    params: parameter
  })
}
 //用户登录--- 查询是否登录
export function webOrLoginQuery (parameter) {
  return axios({
    url: '/api-user-v2/wx/login/webQrLoginQuery',
    method: 'get',
    params: parameter
  })
}
 //用户登录--- 用户详情
export function getUserUpdate (parameter) {
  return axios({
    url: '/api-user-v2/personal/login/user/update',
    method: 'post',
    data: parameter
  })
}
//用户管理--- 修改密码验证码
export function getSmsCaptcha (parameter) {
  return axios({
    url: '/api-user-v2/user/getCode',
    method: 'get',
    params: parameter
  })
}
//用户管理--- 修改密码
export function changePwd (parameter) {
  return axios({
    url: '/api-user-v2/user/changePwd',
    method: 'put',
    data: parameter
  })
}

 //忘记密码验证码
export function getPwdCode (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/resetPwd/one',
    method: 'get',
    params: parameter
  })
}
 //忘记密码
export function editUserPwd (parameter) {
  return axios({
    url: '/api-user-v2/personal/user/resetPwd/two',
    method: 'put',
    data: parameter
  })
}
 //切换平台机构
export function switchOrgList (parameter) {
  return axios({
    url: '/api-user-v2/change/org/web/org/list',
    method: 'get',
    params: parameter
  })
}
//  教学平台登录
export function switchOrg (orgId) {
  return axios({
    url: `/api-user-v2/change/org/mobile/user/${orgId}`,
    method: 'get'
  })
}

//  教学平台登录
export function getOrgToken (parameter) {
  return axios({
    url: '/api-uaa-v2/oauth/uuid/token',
    method: 'post',
     headers: {
      // 请求头
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + window.btoa(config.clientId + ':' + config.clientSecret)
    },
     data: qs.stringify(parameter)
  })
}

//用户登录--- UUID登录
export function uuidLogin (data) {
  return axios({
    url: '/api-uaa-v2/oauth/sub/platform/token',
    method: 'post',
    headers: {
      // 请求头
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + window.btoa(config.clientId + ':' + config.clientSecret)
    },
    data: qs.stringify(data) // 发送请求要传的FormData参数，必须用 qs.stringify（）序列化一下
  })
}
//用户登录--- 账号密码登录
export function pwdLogin (data) {
  return axios({
    url: `/api-uaa-v2/oauth/other/token?webSite=${data.webSite}`,
    method: 'post',
    headers: {
      // 请求头
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + window.btoa(config.clientId + ':' + config.clientSecret)
    },
    data: qs.stringify(data) // 发送请求要传的FormData参数，必须用 qs.stringify（）序列化一下
  })
}

//  忘记密码获取验证码
export function resetPwdCode (parameter) {
  return axios({
    url: `/api-user-v2/personal/user/resetPwd/one`,
    method: 'get',
    params: parameter
  })
}
//  忘记密码获取验证码
export function resetPwd (parameter) {
  return axios({
    url: `/api-user-v2/personal/user/resetPwd/two`,
    method: 'put',
     data: parameter
  })
}


